export default "/images/linkedin.svg?63c51976c890cfadf32bd645f605e75d";